import Store from '@/store'
export default [
  {
    path: '/documentos',
    name: 'documentos-index',
    beforeEnter: async (to, from, next) => {
      next()
    },
    meta: {
      title: 'Documentos para impressão',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "documento" */ '@/views/documento')
    }
  },
  {
    path: '/documentos/anexo-xi-programa-leite-mais-em-branco',
    name: 'empty-anexo-ix-print',
    beforeEnter: async (to, from, next) => {
      await Store.commit('setClientes', [])
      await Store.dispatch('getIndustrias')
      next()
    },
    meta: {
      title: 'ANEXO IV do Programa Leite Mais (Em Branco)',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/documento/anexo_ix/empty'
      )
    }
  },
  {
    path: '/documentos/anexo-xi-programa-leite-mais-completo',
    name: 'full-anexo-ix-print',
    beforeEnter: async (to, from, next) => {
      await Store.commit('setLaudos', [])
      await Store.dispatch('getIndustrias')
      next()
    },
    meta: {
      title: 'ANEXO IV do Programa Leite Mais (Completo)',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/documento/anexo_ix/full'
      )
    }
  }
]
